import email from '../assets/email.png';
import mobile from '../assets/mobile.png';
import api from '../assets/api.png';
import cpp from '../assets/cpp.png';
import css from '../assets/css.png';
import figma from '../assets/figma.png';
import flutter from '../assets/flutter.png';
import git from '../assets/git.png';
import graphql from '../assets/graphql.png';
import html from '../assets/html.png';
import javascript from '../assets/javascript.png';
import mu5 from '../assets/mu5.png';
import node from '../assets/node.png';
import python from '../assets/python.png';
import react1 from '../assets/react1.png';
import react2 from '../assets/react2.png';
import redux from '../assets/redux.png';
import sass from '../assets/sass.png';
import typescript from '../assets/typescript.png';
import vue from '../assets/vue.png';
import androidstudio from '../assets/androidstudio.png';
import java from '../assets/java.png';
import sql from '../assets/sql.png';
import csharp from '../assets/C#.png';
import expo from '../assets/expo.png';
import sitecore from '../assets/sitecore.png';

import typescriptIcon from '../assets/icons/typescript.svg';
import reactIcon from '../assets/icons/react.svg';
import csharpIcon from '../assets/icons/csharp.svg';
import pythonIcon from '../assets/icons/python.svg';
import mysqlIcon from '../assets/icons/mysql.svg';
import graphqlIcon from '../assets/icons/graphql.svg';
import nodejsIcon from '../assets/icons/nodejs.svg';
import awsIcon from '../assets/icons/aws.svg';
import javaIcon from '../assets/icons/java.svg';
import sitecoreIcon from '../assets/icons/sitecore.svg';

import about01 from '../assets/about01.png';
import about02 from '../assets/about02.png';
import about03 from '../assets/about03.png';
import about04 from '../assets/about04.png';

import profile1 from '../assets/ProfilePic1.png';
import profile2 from '../assets/ProfilePic2.png';
import circle from '../assets/circle.svg';
import frankTitle from '../assets/FrankTitle.png';

import chessapp from '../assets/chessapp.png';
import mobileapp from '../assets/mobileapp.png';

const images = {
  email,
  mobile,
  api,
  cpp,
  css,
  figma,
  flutter,
  git,
  graphql,
  html,
  javascript,
  mu5,
  node,
  python,
  react1,
  react2,
  redux,
  sass,
  typescript,
  vue,
  androidstudio,
  java,
  sql,
  csharp,
  about01,
  about02,
  about03,
  about04,
  profile1,
  profile2,
  circle,
  frankTitle,
  chessapp,
  mobileapp,
  expo,
  sitecore,
  typescriptIcon,
  reactIcon,
  csharpIcon,
  pythonIcon,
  mysqlIcon,
  graphqlIcon,
  nodejsIcon,
  awsIcon,
  javaIcon,
  sitecoreIcon,
};

export default images;
  